import React from 'react';

import SupervisorParametro  from 'components/Tvendo/Sale/QuotaBPartner/ReglaParametro/SupervisorParam/List.js';

export default function () {
  return <SupervisorParametro  />;
}